import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../../../services/common/common.service';
import { WidgetHelperService } from '../widget-helper.service';
import { WidgetService } from '../../../services/widget/widget.service'
import { UserService } from "../../../services/user/user.service";
declare var webix: any;

@Component({
  selector: 'compare-table',
  templateUrl: './compare-table.component.html',
  styleUrls: ['./compare-table.component.scss']
})
export class CompareTableComponent implements OnInit {
  @Input('graphData') graphData: any;
  @Input('isEditable') isEditable: any;
  @Input('groupId') groupId: any;
  @Input('groupData') groupData: any;
  @Input('widget') widget: any;
  @Input('is-schedule') _scheduled: boolean = false;
  widgetId = "";
  pageInex = 1;
  pivotGrid: any = null;
  pager: any = null;

  constructor(private commonService: CommonService, private widgetHelperService: WidgetHelperService, private widgetService: WidgetService, public userService: UserService) {
    commonService.getAction().subscribe(data => {
    });
  }

  ngOnInit() {
    this.widgetId = this.graphData.udf.widgetId;
    //this.processTD(this.widgetId);
  }

  ngAfterViewInit() {
    setTimeout(() => {

      this.processTD(this.widgetId);
    }, 100);
  }

  processTD(id: any) {
    let that = this;
    this.widgetId = this.graphData.udf.widgetId;
    let values = [];
    if (this.graphData.dataFilter && this.graphData.dataFilter.constructor == Array && this.graphData.dataFilter.length > 0) {
      let dimensions = this.graphData.udf.compareConfig.tableAdjust;
      let varName = this.graphData.udf.compareConfig.valueType.variationName ? this.graphData.udf.compareConfig.valueType.variationName : 'Variance', difName = this.graphData.udf.compareConfig.valueType.differanceName ? this.graphData.udf.compareConfig.valueType.differanceName : 'Difference';
      let res = this.widgetHelperService.getCompareDataTable(this.graphData), adjustHeaderLabel = false;
      if (res) {
        if (this.graphData.udf.compareConfig.tableAdjust.hasOwnProperty('tableHeader'))
          adjustHeaderLabel = this.graphData.udf.compareConfig.tableAdjust.tableHeader;
        res.Site.forEach((site) => {
          site.ValueFilter.forEach((v, i) => {
            var sname = site.sanitized + '_' + v.name.replace(/ /g, '_');
            if (i === 0)
              values.push({
                id: sname, header: [{ text: site.name, colspan: site.ValueFilter.length }, v.name], sort: v.sort, fillspace: true, minWidth: 150, adjust: (adjustHeaderLabel ? "data" : "")
              });
            else {
              if (v.name.indexOf(difName) > -1) {
                values.push({
                  id: sname, header: ["", v.name], minWidth: 150, sort: 'int', css: { "background-color": res.Color[sname], 'text-align': 'right' }, adjust: (adjustHeaderLabel ? "header" : ""), template: function (obj) {
                    if (obj[sname] === '')
                      return '';
                    var val: any = parseFloat(obj[sname]);
                    if (isNaN(val))
                      return '';
                    if (val > 0) {
                      val = (res.formatNumber[sname] == "-1" ? that.commonService.shortNumberFormat(val) : val.toFixed(res.formatNumber[sname]));
                      if (res.isThousandSeperator[sname])
                        return '<span ' + (res.Indicators.color ? 'style="color:#03c04a"' : '') + '>' + that.commonService.formatNumberString(val, true) + (res.Indicators.arrow ? '&nbsp;&#x25B2;' : '') + '</span>';
                      else
                        return '<span ' + (res.Indicators.color ? 'style="color:#03c04a"' : '') + '>' + that.commonService.formatNumberString(val, false) + (res.Indicators.arrow ? '&nbsp;&#x25B2;' : '') + '</span>';
                    }
                    else if (val < 0) {
                      val = (res.formatNumber[sname] == "-1" ? that.commonService.shortNumberFormat(val) : val.toFixed(res.formatNumber[sname]));
                      if (res.isThousandSeperator[sname])
                        return '<span ' + (res.Indicators.color ? 'style="color:#ff0000"' : '') + '>' + that.commonService.formatNumberString(val, true) + (res.Indicators.arrow ? '&nbsp;&#x25BC;' : '') + '</span>';
                      else
                        return '<span ' + (res.Indicators.color ? 'style="color:#ff0000"' : '') + '>' + that.commonService.formatNumberString(val, false) + (res.Indicators.arrow ? '&nbsp;&#x25BC;' : '') + '</span>';
                    }
                    else
                      return 0;
                  }
                });
              }
              else if (v.name.indexOf(varName) > -1) {
                values.push({
                  id: sname, header: ["", v.name], minWidth: 150, sort: 'int', css: { "background-color": res.Color[sname], 'text-align': 'right' }, adjust: (adjustHeaderLabel ? "header" : ""), template: function (obj) {
                    if (obj[sname] === '')
                      return '';
                    var val: any = parseFloat(obj[sname]);
                    if (isNaN(val))
                      return '';
                    if (val > 0) {
                      val = (res.formatNumber[sname] == "-1" ? that.commonService.shortNumberFormat(val) : val.toFixed(res.formatNumber[sname]));
                      if (res.isThousandSeperator[sname])
                        return '<span ' + (res.Indicators.color ? 'style="color:#03c04a"' : '') + '>' + that.commonService.formatNumberString(val, true) + '%' + (res.Indicators.arrow ? '&nbsp;&#x25B2;' : '') + '</span>';
                      else
                        return '<span ' + (res.Indicators.color ? 'style="color:#03c04a"' : '') + '>' + that.commonService.formatNumberString(val, false) + '%' + (res.Indicators.arrow ? '&nbsp;&#x25B2;' : '') + '</span>';
                    }
                    else if (val < 0) {
                      val = (res.formatNumber[sname] == "-1" ? that.commonService.shortNumberFormat(val) : val.toFixed(res.formatNumber[sname]));
                      if (res.isThousandSeperator[sname])
                        return '<span ' + (res.Indicators.color ? 'style="color:#ff0000"' : '') + '>' + that.commonService.formatNumberString(val, true) + '%' + (res.Indicators.arrow ? '&nbsp;&#x25BC;' : '') + '</span>';
                      else
                        return '<span ' + (res.Indicators.color ? 'style="color:#ff0000"' : '') + '>' + that.commonService.formatNumberString(val, false) + '%' + (res.Indicators.arrow ? '&nbsp;&#x25BC;' : '') + '</span>';
                    }
                    else
                      return 0;
                  }
                });
              }
              else
                values.push({
                  id: sname, header: ["", v.name], minWidth: 150, sort: v.sort, css: { "background-color": res.Color[sname], 'text-align': 'right' }, adjust: (adjustHeaderLabel ? "header" : ""), template: function (obj) {
                    var val: any = obj[sname] ? parseFloat(obj[sname]) : obj[sname];
                    if (val) {
                      val = (res.formatNumber[sname] == "-1" ? that.commonService.shortNumberFormat(val) : val.toFixed(res.formatNumber[sname]));
                      if (res.isThousandSeperator[sname])
                        val = that.commonService.formatNumberString(val, true);
                      else
                        val = that.commonService.formatNumberString(val, false);
                    }
                    return val;
                  }
                });
            }
          });
        });

        $(function () {
          values.forEach(_column => {
            let frray = res.footerData.map(function (o) {
              if (!isNaN(o[_column.id]) || o[_column.id].indexOf('<span') > -1) {
                var val = o[_column.id], span = '', oval = '';
                if (typeof val === 'string' && val.indexOf('<span') > -1) {
                  span = val;
                  if (val.indexOf('&nbsp;') > -1)
                    val = oval = val.substring(val.indexOf('>') + 1, val.indexOf('&nbsp;')).replace('%', '');
                  else
                    val = oval = val.substring(val.indexOf('>') + 1, val.indexOf('</')).replace('%', '');
                  val = Number(val)
                }
                if (val > 0 || val < 0) {
                  val = (res.formatNumber[_column.id] == "-1" ? that.commonService.shortNumberFormat(val) : parseFloat(val).toFixed(res.formatNumber[_column.id]));
                  if (res.isThousandSeperator[_column.id])
                    val = that.commonService.formatNumberString(val, true);
                  else
                    val = that.commonService.formatNumberString(val, false);
                  if (span)
                    return span.replace(oval, val);
                  return val;
                }
                else
                  return 0;
              }
              else
                return "<span style='display:block;text-align:left'>" + o[_column.id] + "</span>";
            });
            _column['footer'] = frray;
          });
          let dtConfig = {
            container: ("compareTable" + that.widgetId),
            id: ("table" + that.widgetId),
            css: "webix_header_border",
            view: "datatable",
            columns: values,
            autowidth: true,
            data: res.Data,
            footer: (res.footerData.length > 0)
          };
          if (dimensions) {
            let rows = Number(dimensions.tableRows);
            if (rows > 0) {
              dtConfig['height'] = (rows * 36) + ((2 + res.footerData.length) * 43);
            }
            else {
              dtConfig['autoheight'] = true;
            }

            if (dimensions.tableWidth) {
              dtConfig['css'] = dtConfig['css'] + " compare_center";
            }
            if (dtConfig['autoheight']) {
              if ((res.Data.length + 5) >= 24) {
                dtConfig['height'] = 600;
                delete dtConfig['autoheight'];
              }
            }
          }
          else {
            if ((res.Data.length + 5) >= 24)
              dtConfig['height'] = 600;
            else
              dtConfig['autoheight'] = true;
          }
          if (that._scheduled)
            dtConfig['autoheight'] = true;
          that.pivotGrid = webix.ui(dtConfig);
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/compare-table/compare-table.component.ts